module.exports = __webpack_public_path__ + "static/media/market-research.1687a22b.png";